import { Link } from '@/types/schema/kol-schema'
import { Link as KolInfoLink } from '@/types/schema/kol/link-schema'

const convertKolInfoLinkToKolSchemaLink = (link: KolInfoLink): Link => {
  return {
    platformType: link.platform_type,
    type: link.type,
    url: link.url,
    permanentURL: link.permanent_url,
    description: link.description,
    nameList: link.name_list,
  }
}

export default convertKolInfoLinkToKolSchemaLink
